import { lazyPage } from "@/router/lazyPage";

export const CashFlowPage = lazyPage(() => import("@/pages/Finance/CashFlowPage"), "CashFlowPage");
export const FinanceIndexRedirect = lazyPage(
  () => import("@/pages/Finance/FinanceLayout"),
  "FinanceIndexRedirect",
);
export const FinanceLayout = lazyPage(
  () => import("@/pages/Finance/FinanceLayout"),
  "FinanceLayout",
);
export const ProjectPayables = lazyPage(
  () => import("@/pages/Finance/ProjectPayables"),
  "ProjectPayables",
);
export const ProjectReceivables = lazyPage(
  () => import("@/pages/Finance/ProjectReceivables"),
  "ProjectReceivables",
);
export const FiscalDocuments = lazyPage(
  () => import("@/pages/Finance/FiscalDocuments"),
  "FiscalDocuments",
);
